<template lang="pug">
div
	.infosheet
		//- .font-weight-bold TODO: polis info?

	.flow-left
		h1 Mijn verzekering

		//- status: loading
		v-card(v-if="isLoading" outlined)
			v-card-title Toegang tot jouw verzekeringsinformatie
			v-card-subtitle Een klein ogenblik geduld, je gegevens worden opgehaald.
			v-card-text
				v-progress-circular(indeterminate color="primary")
		template(v-else)
			v-card(oulined flat style="border: 1px solid white;")
				v-card-text.pt-0.pr-0.text-right
					v-btn(small color="error" @click="logout()" outlined) Uitloggen Mijn Verzekering
			v-card.mb-4(outlined)
				v-card-title
					h2.font-weight-bold.body-1 Ik wil graag:
				v-card-text
					v-expansion-panels(focussable :disabled="isDisabled")
						v-expansion-panel
							v-expansion-panel-header.font-weight-bold 1. Mijn gegevens en/of verzekeringspolis aanpassen
							v-expansion-panel-content
								p Klik op de blauwe button om uw naam, adres en/of contactgegevens aan te passen. Ook voor het doorgeven van een wijziging op uw verzekeringspolis – bijvoorbeeld het aan- of afmelden van gezinsleden of het wijzigen van de dekking - kunt u deze button gebruiken.
								h3.font-weight-bold.body-2 Voor welke polis wilt u de gegevens aanpassen?
								v-select(v-if="activePolicies.length" v-model="selectedPolicy" :items="activePolicies.map(p => {return {value: p.polisnummer, text: `${p.polisnummer} ${p.omschrijving} ${this.isActivePolis(p)}`};})" label="Kies een polisnummer" hint="" persistent-hint outlined)
								v-alert.mt-2.caption(v-else text type="warning") We hebben helaas geen polis kunnen vinden, neemt u alstublieft contact op met de ledenservice.
								v-btn(color="primary" @click="submitFinconnect('4273')" :disabled="isButtonDisabled || !selectedPolicy") gegevens aanpassen
									v-progress-circular.ml-2(v-if="isButtonDisabled" right indeterminate :size="15" :width="1" color="grey")
						v-expansion-panel(v-if="activePolicies.filter(p => p.omschrijving !== 'Lidmaatschap').length > 0")
							v-expansion-panel-header.font-weight-bold 2. Een schade melden
							v-expansion-panel-content
								p Klik op de blauwe button om naar het online schadeformulier te gaan.
								h3.font-weight-bold.body-2 Voor welke verzekeringspolis wilt u schade melden?
								v-select(v-if="activePolicies.length" v-model="selectedPolicy" :items="activePolicies.filter(p => p.omschrijving !== 'Lidmaatschap').map(p => {return {value: p.polisnummer, text: `${p.polisnummer} ${p.omschrijving} ${this.isActivePolis(p)}`};})" label="Kies een polisnummer" hint="" persistent-hint outlined)
								v-alert.mt-2.caption(v-else text type="warning") We hebben helaas geen polis kunnen vinden, neemt u alstublieft contact op met de ledenservice.
								v-btn(color="primary" @click="submitFinconnect('4390')" :disabled="isButtonDisabled || !selectedPolicy || selectedPolicyType === 'Lidmaatschap'") schade melden
									v-progress-circular.ml-2(v-if="isButtonDisabled" right indeterminate :size="15" :width="1" color="grey")
						//- v-expansion-panel
							v-expansion-panel-header.font-weight-bold 3. Overige vragen
							v-expansion-panel-content
								p We helpen onze leden graag persoonlijk. Daarom vragen we je contact op te nemen met de servicedesk. Dit kan telefonisch of per e-mail.
								v-card.mb-4(outlined color="info")
									v-card-text.accent--text
										v-row(dense)
											v-col.shrink
												ws-icon(small) envelope
											v-col
												a.external(href="mailto:verzekeren@wintersport.nl" target="_blank" rel="nofollow") verzekeren@wintersport.nl
										v-row(dense)
											v-col.shrink
												ws-icon(small) phone
											v-col
												a.external(href="tel:+31303077812" target="_blank" rel="nofollow") +31 (0)30 30 77 812
										small Bereikbaar op werkdagen tussen 09:00 en 17:00 uur

			v-card.mb-4(outlined)
				v-card-title
					h2.font-weight-bold.body-1 Overzicht van uw verzekeringen en/of lidmaatschappen:
				v-card-text
					v-expansion-panels(focussable :disabled="isDisabled")
						v-expansion-panel(v-for="policy in this.activePolicies" :key="policy.polisnummer")
							v-expansion-panel-header.font-weight-bold {{policy.omschrijving}} ({{policy.polisnummer}})
							v-expansion-panel-content
								h2.font-weight-bold.body-2 Contract:
								v-simple-table.mb-4
									template(#default)
										thead
											tr
												th Ingangsdatum
												th Vervaldatum
												th Incassobedrag
										tbody
											tr
												td {{$dayjs(policy.ingangsdatum).format('DD-MM-YYYY')}}
												td {{$dayjs(policy.contractvervaldatum).format('DD-MM-YYYY')}}
												td {{$n(policy.incassobedrag, 'currency', $i18n.locale)}}
								h2.font-weight-bold.body-2 {{policy.omschrijving === 'Lidmaatschap' ? 'Leden:' : 'Verzekerden:'}}
								v-simple-table.mb-4
									template(#default)
										thead
											tr
												th(v-if="policy.omschrijving === 'Lidmaatschap'") Lidnummer
												th Naam
												th Geboortedatum
										tbody
											template(v-for="verzekerde in policy.verzekerden")
												tr
													td(v-if="policy.omschrijving === 'Lidmaatschap'") {{verzekerde.lidnummer}}
													td {{verzekerde.voorletters}}{{verzekerde.tussenvoegsel ? ` ${verzekerde.tussenvoegsel} ` : ' '}}{{verzekerde.achternaam}}
													td {{$dayjs(verzekerde.geboortedatum).format('DD-MM-YYYY')}}
								template(v-if="policy.omschrijving !== 'Lidmaatschap'")
									h2.font-weight-bold.body-2 Dekkingen:
									v-simple-table
										template(#default)
											thead
												tr
													th Dekking
											tbody
												template(v-for="dekking in policy.dekkingen")
													tr
														td {{dekking.dekkingcode}}
									v-alert.mt-2.caption(type="info" color="primary" text dense) Op uw polisblad is de specifieke invulling van de dekkingen te vinden.
</template>

<script>
import gql from 'graphql-tag';
import cookies from 'js-cookie';

export default {
	name: 'InsuranceProfile',
	components: {},
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/profiel'
		}
	},
	asyncData({ app }) {
		app.ads({});
		app.meta({
			title: 'Mijn verzekering - Nederlandse Ski Vereniging',
			description:
				'In het persoonlijke profiel vind je alle informatie van jouw persoonlijke verzekering. Je kunt je polis aanpassen, gegevens wijzigen en de polisbladen inzien'
		});
		app.breadcrumbs({
			[app.i18n.t('page.insurance:breadcrumb')]: { name: 'verzekering' },
			[app.i18n.t('page.insurance.travel:breadcrumb')]: {
				name: 'verzekering-reisverzekering'
			},
			[app.i18n.t('page.insurance.profile:breadcrumb')]: {
				name: 'verzekering-profiel'
			}
		});
	},
	data() {
		return {
			isLoading: true,
			isDisabled: true,
			isButtonDisabled: false,
			polisAndRelation: {},
			selectedPolicy: false
		};
	},
	computed: {
		activePolicies() {
			return this.polisAndRelation.policies.filter(p =>
				this.$dayjs().isBefore(this.$dayjs(p.contractvervaldatum))
			);
		},
		selectedPolicyType() {
			if (!this.selectedPolicy) return null;

			const policy = this.activePolicies.find(
				p => p.polisnummer === this.selectedPolicy
			);
			return policy ? policy.omschrijving : null;
		}
	},
	mounted() {
		this.getPolis();
	},
	methods: {
		getPolis() {
			this.$graphClient
				.query({
					query: gql`
						query {
							polisAndRelation: GetPolisAndRelation {
								policies {
									polisnummer
									omschrijving
									ingangsdatum
									contractvervaldatum
									incassobedrag
									verzekerden {
										achternaam
										geboortedatum
										tussenvoegsel
										voorletters
										lidnummer
									}
									dekkingen {
										dekkingcode
									}
								}
							}
						}
					`
				})
				.then(({ data }) => {
					if (!data.polisAndRelation)
						return this.$router.push(
							this.localePath({
								name: 'verzekering-login'
							})
						);

					this.polisAndRelation.relation = data.polisAndRelation.relation
						? data.polisAndRelation.relation
						: null;
					this.polisAndRelation.policies = data.polisAndRelation.policies
						? data.polisAndRelation.policies
						: [];
					if (this.polisAndRelation.policies.length === 1)
						this.selectedPolicy = this.polisAndRelation.policies[0].polisnummer;

					this.isLoading = false;
					this.isDisabled = false;
				})
				.catch(_error => {
					this.logout();
				});
		},
		isActivePolis(policy) {
			if (!policy.contractvervaldatum) return '';
			return this.$dayjs().isBefore(this.$dayjs(policy.contractvervaldatum))
				? `(actief tot ${this.$dayjs(policy.contractvervaldatum).format(
						'DD-MM-YYYY'
				  )})`
				: `(vervallen op ${this.$dayjs(policy.contractvervaldatum).format(
						'DD-MM-YYYY'
				  )})`;
		},
		submitFinconnect(formCode) {
			this.isDisabled = true;
			this.isButtonDisabled = true;
			this.$graphClient
				.query({
					query: gql`
						query ($formCode: String!, $policyNumber: String!) {
							finconnectForm: GetFinconnectForm(
								formCode: $formCode
								policyNumber: $policyNumber
							) {
								redirect
							}
						}
					`,
					variables: {
						formCode,
						policyNumber: this.selectedPolicy
					}
				})
				.then(({ data }) => {
					this.isDisabled = false;
					this.isButtonDisabled = false;
					if (data.finconnectForm && data.finconnectForm.redirect)
						window.open(data.finconnectForm.redirect, '_blank');
				})
				.catch(_error => {
					this.isDisabled = false;
					this.isButtonDisabled = false;
				});
		},
		logout() {
			cookies.remove('insurance-token');
			return this.$router.push(
				this.localePath({
					name: 'verzekering-login'
				})
			);
		}
	}
};
</script>
